import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { RuleTranslator } from '@cbridge-packages/rule';
import { AdjustmentRuleAction } from '../adjustmentRule.action';
import { AdjustmentRuleTranslator } from '../adjustmentRule.translator';

type IDependencies = IClientApiDependencySegment;

export const updateAdjustmentRuleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(AdjustmentRuleAction.update.started),
  mergeMap((params) => {
    const rules = params.map(AdjustmentRuleTranslator.toApi);
    return dependencies.api.updateAdjustmentRules({ rules }).pipe(
      mergeMap((response) => {
        return [
          AdjustmentRuleAction.update.done({ params, result: (response.rules ?? []).map(RuleTranslator.fromApiValidation) }),
        ];
      }),
      catchApiError((error) => {
        return [
          AdjustmentRuleAction.update.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
